// components/ProfileStats.js
import React, { useState } from "react";
import { FaHeart, FaRegHeart, FaUserPlus, FaComment, FaCoins, FaExpand } from "react-icons/fa";

const ProfileStats = ({ authUser, coinBalance }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Hàm mở modal để xem hình phóng to
  const openImageModal = (photoUrl) => {
    setSelectedImage(photoUrl);
  };

  // Hàm đóng modal
  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <div className="bg-green-600 text-white p-4 shadow-md mb-6 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="relative w-12 h-12">
            <img
              src={
                authUser?.primaryPhoto?.photoUrl ||
                authUser?.mainImage ||
                authUser?.avatar ||
                "https://placehold.co/50"
              }
              alt={`${authUser.name}'s profile avatar`}
              className="w-full h-full object-cover rounded-full shadow-lg border-4 border-white cursor-pointer"
              onError={(e) => (e.target.src = "https://placehold.co/50")}
              onClick={() =>
                openImageModal(
                  authUser?.primaryPhoto?.photoUrl ||
                    authUser?.mainImage ||
                    authUser?.avatar ||
                    "https://placehold.co/50"
                )
              }
            />
            <button
              onClick={() =>
                openImageModal(
                  authUser?.primaryPhoto?.photoUrl ||
                    authUser?.mainImage ||
                    authUser?.avatar ||
                    "https://placehold.co/50"
                )
              }
              className="absolute bottom-0 right-0 bg-gray-800 text-white p-1 rounded-full hover:bg-gray-600 transition-colors"
            >
              <FaExpand size={12} />
            </button>
          </div>
          <div>
            <h2 className="text-xl font-semibold">Chào {authUser.name}</h2>
            <p className="text-sm">
              Bước Tiếp Theo: Tải ảnh và hoàn thiện hồ sơ
              <br />
              Quý hội viên Bắc Kim Cương của bạn
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-white text-lg font-semibold">
              23%
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="flex flex-col items-center">
              <FaHeart size={24} />
              <span className="text-sm">0</span>
            </div>
            <div className="flex flex-col items-center">
              <FaComment size={24} />
              <span className="text-sm">0</span>
            </div>
            <div className="flex flex-col items-center">
              <FaUserPlus size={24} />
              <span className="text-sm">0</span>
            </div>
            <div className="flex flex-col items-center">
              <FaRegHeart size={24} />
              <span className="text-sm">0</span>
            </div>
            <div className="flex flex-col items-center">
              <FaCoins size={24} className="text-yellow-300" />
              <span className="text-sm">{coinBalance}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Modal để xem hình phóng to */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeImageModal}
        >
          <div className="relative max-w-3xl max-h-[80vh]">
            <img
              src={selectedImage}
              alt="Hình phóng to"
              className="w-full h-full object-contain rounded-lg"
              onError={(e) => (e.target.src = "https://placehold.co/600")}
            />
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 bg-gray-800 text-white p-2 rounded-full hover:bg-gray-600 transition-colors"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileStats;